interface Geolocation {
  latitude: number;
  longitude: number;
}

export const getGeolocation = (): Promise<Geolocation> => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          reject(new Error('Failed to get geolocation'));
        }
      );
    } else {
      reject(new Error('Geolocation is not supported by this browser'));
    }
  });
};
